// pp-customer-recompra.js — Orquesta la página de Recompra Rápida rediseñada.
//
// Responsabilidades (el comportamiento del renglón —stepper, subtotal en vivo,
// agregar-todo— sigue en pp-customer-dashboard.js, delegado a `document`):
//   1. Selector de fuente (chips): Historial · Favoritos · Consumo (Fase 2).
//      Solo la fuente ACTIVA vive en el DOM, para que ppRecalcReorder() y el
//      "agregar todo" cuenten únicamente esos items (las inactivas se guardan
//      en un DocumentFragment en memoria).
//   2. Favoritos: window.PPWishlist → IDs → handles (section pp-wishlist-id-map)
//      → un item por handle (section pp-reorder-single) → mismo markup que el
//      historial → ppRecalcReorder().
//   3. Aside "Completa Tu Pedido": motor pp-recommendations sembrado con el
//      producto más comprado (mismo patrón que la página de Favoritos).
//   4. Seleccionar todo + contador.
(function () {
  'use strict';

  var root = document.querySelector('[data-pp-recompra]');
  if (!root) return;

  var listEl = root.querySelector('[data-pp-reorder-list]');
  var footEl = root.querySelector('[data-pp-reorder-foot]');
  var statusEl = root.querySelector('[data-pp-reorder-status]');
  var tabsEl = root.querySelector('[data-pp-source-tabs]');
  var noteEl = root.querySelector('[data-pp-source-note]');
  var selectAllEl = root.querySelector('[data-pp-reorder-selectall]');
  var countEl = root.querySelector('[data-pp-reorder-count]');
  if (!listEl) return;

  var NOTES = {
    historial: 'Lo que más has comprado en tus últimas 10 órdenes.',
    favoritos: 'Los productos que guardaste como favoritos.',
    consumo: 'Lo que ya te toca reponer según tu ritmo de compra.',
    personalizados: 'Los empaques que ya compraste con tu diseño. Ábrelos y pide de nuevo — tú decides la cantidad.'
  };

  // Caché de fuentes: solo una está montada a la vez.
  var cache = { historial: null, favoritos: null, consumo: null, personalizados: null };
  var loaded = { historial: true, favoritos: false, consumo: false, personalizados: false };
  var active = 'historial';

  function recalc() {
    if (typeof window.ppRecalcReorder === 'function') window.ppRecalcReorder();
  }

  function currentItems() {
    return listEl.querySelectorAll('[data-pp-reorder-item]');
  }

  // Refleja conteo + estado del "seleccionar todo" + visibilidad del footer.
  function syncControls() {
    var items = currentItems();
    var total = items.length;
    var selected = 0;
    items.forEach(function (it) {
      var chk = it.querySelector('[data-pp-reorder-check]');
      if (chk && chk.checked) selected++;
    });
    if (countEl) {
      countEl.textContent = total === 0 ? '' : (selected + ' de ' + total + ' seleccionados');
    }
    if (selectAllEl) {
      selectAllEl.checked = total > 0 && selected === total;
      selectAllEl.indeterminate = selected > 0 && selected < total;
      selectAllEl.disabled = total === 0;
    }
    var toolbar = root.querySelector('.pp-recompra__toolbar');
    if (toolbar) toolbar.hidden = total === 0;
    if (footEl) footEl.hidden = total === 0;
  }

  function afterRender() {
    recalc();
    syncControls();
  }

  function showStatus(msg, kind) {
    if (!statusEl) return;
    statusEl.textContent = msg;
    statusEl.className = 'pp-recompra__status' + (kind ? ' pp-recompra__status--' + kind : '');
    statusEl.hidden = false;
  }
  function hideStatus() {
    if (statusEl) { statusEl.hidden = true; statusEl.className = 'pp-recompra__status'; }
  }

  // Filas esqueleto mientras carga una fuente (favoritos/consumo) — reserva el
  // espacio de los renglones para que no brinque cuando llegan. Reusa pp-skel.
  function showSkeletonList(rows) {
    if (!statusEl) return;
    while (statusEl.firstChild) statusEl.removeChild(statusEl.firstChild);
    statusEl.className = 'pp-recompra__status pp-skel-list';
    for (var i = 0; i < rows; i++) {
      var row = document.createElement('div');
      row.className = 'pp-skel-list__row';
      var thumb = document.createElement('span');
      thumb.className = 'pp-skel pp-skel-list__thumb';
      var lines = document.createElement('div');
      lines.className = 'pp-skel-list__lines';
      var t = document.createElement('span');
      t.className = 'pp-skel pp-skel--title';
      var s = document.createElement('span');
      s.className = 'pp-skel pp-skel--text';
      lines.appendChild(t); lines.appendChild(s);
      row.appendChild(thumb); row.appendChild(lines);
      statusEl.appendChild(row);
    }
    statusEl.hidden = false;
  }

  // Guarda los nodos actuales de la lista en su fragmento de caché.
  function stash(source) {
    var frag = document.createDocumentFragment();
    while (listEl.firstChild) frag.appendChild(listEl.firstChild);
    cache[source] = frag;
  }
  // Monta el fragmento de una fuente en la lista.
  function mount(source) {
    if (cache[source]) listEl.appendChild(cache[source]);
    cache[source] = null;
  }

  function buildEmpty(source, msg) {
    var frag = document.createDocumentFragment();
    var box = document.createElement('div');
    box.className = 'pp-dash__empty';
    var p = document.createElement('p');
    p.className = 'pp-dash__empty-text';
    p.textContent = msg;
    box.appendChild(p);
    frag.appendChild(box);
    cache[source] = frag;
    loaded[source] = true;
  }

  function switchSource(next) {
    if (next === active) return;
    stash(active);
    hideStatus();
    active = next;
    updateTabs();
    if (noteEl) noteEl.textContent = NOTES[next] || '';

    if (loaded[next]) {
      mount(next);
      afterRender();
    } else if (next === 'favoritos') {
      showSkeletonList(5);
      loadFavoritos();
    } else if (next === 'consumo') {
      showSkeletonList(5);
      loadConsumo();
    } else if (next === 'personalizados') {
      showSkeletonList(4);
      loadPersonalizados();
    }
  }

  // ── Tus Personalizados ───────────────────────────────────────────
  //
  // La única fuente cuyos renglones NO van al carrito. Un personalizado se
  // vuelve a pedir ABRIÉNDOLO en el estudio: la cantidad la pone el cliente
  // allá (fue el pedido explícito) y el precio se cotiza con las reglas de
  // volumen del día. Mandar aquí un precio viejo sería prometer uno que el
  // carrito no va a cobrar.
  //
  // La pertenencia NO se decide aquí: el edge vuelve a verificar que esas
  // compras sean de su empresa. Esta lista es presentación.
  //
  // Desde el 4-oct-2026 sale de /customer-disenos (los COMPRADOS): son de toda
  // la empresa aunque el comprador ya no esté, y cada uno trae `abrir_url`
  // firmada que el estudio reabre en CUALQUIER dispositivo. Antes la liga era
  // ?designId= a secas y desde otra computadora abría el editor vacío.
  function urlDelEstudio(u) {
    return typeof u === 'string' && u.indexOf('https://print.parapaquetes.com/estudio/') === 0 ? u : null;
  }

  function fechaCorta(iso) {
    var d = new Date(iso);
    if (isNaN(d.getTime())) return '';
    try {
      return d.toLocaleDateString('es-MX', { day: 'numeric', month: 'short', year: 'numeric' });
    } catch (e) { return ''; }
  }

  function tarjetaPersonalizado(p) {
    var ultima = (p.compras && p.compras[0]) || null;
    var url = urlDelEstudio(p.abrir_url);
    var art = document.createElement(url ? 'a' : 'div');
    art.className = 'pp-recompra__perso';
    if (url) art.href = url;
    // Se abre en pestaña nueva: el estudio es otra aplicación y perder esta
    // lista al volver haría que el cliente tuviera que buscarla otra vez.
    art.target = '_blank';
    art.rel = 'noopener';

    var fig = document.createElement('div');
    fig.className = 'pp-recompra__perso-img';
    if (p.mockup_url) {
      var img = document.createElement('img');
      img.src = p.mockup_url;
      img.alt = '';
      img.loading = 'lazy';
      fig.appendChild(img);
    }
    art.appendChild(fig);

    var cuerpo = document.createElement('div');
    cuerpo.className = 'pp-recompra__perso-body';

    var t = document.createElement('p');
    t.className = 'pp-recompra__perso-title';
    t.textContent = p.nombre || (p.producto && p.producto.nombre) || 'Tu diseño';
    cuerpo.appendChild(t);

    if (p.producto && p.producto.sku) {
      var sku = document.createElement('p');
      sku.className = 'pp-recompra__perso-sku';
      sku.textContent = p.producto.sku;
      cuerpo.appendChild(sku);
    }

    if (ultima) {
      var meta = document.createElement('p');
      meta.className = 'pp-recompra__perso-meta';
      // PAQUETES, no piezas: es la unidad en que se guardó la compra y en la
      // que el cliente pidió. Decir "piezas" multiplicaría el número por 25.
      var n = ultima.cantidad;
      meta.textContent = n + ' paquete' + (n === 1 ? '' : 's') + ' · ' + fechaCorta(ultima.fecha);
      cuerpo.appendChild(meta);
    }

    var cta = document.createElement('span');
    cta.className = 'pp-recompra__perso-cta';
    cta.textContent = 'Volver a pedir';
    cuerpo.appendChild(cta);

    art.appendChild(cuerpo);
    return art;
  }

  function loadPersonalizados() {
    fetch('/apps/crm/customer-disenos', {
      credentials: 'same-origin',
      headers: { 'Accept': 'application/json' }
    })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (d) {
        var lista = (d && d.comprados) || [];
        cache.personalizados = lista;
        loaded.personalizados = true;
        if (active !== 'personalizados') return;
        pintarPersonalizados(lista);
      })
      .catch(function () {
        loaded.personalizados = true;
        cache.personalizados = [];
        if (active === 'personalizados') pintarPersonalizados([]);
      });
  }

  function pintarPersonalizados(lista) {
    if (!listEl) return;
    listEl.textContent = '';
    if (!lista.length) {
      // El vacío EXPLICA por qué está vacío: "no hay nada" deja a quien sí
      // compró pensando que perdió su diseño.
      var vacio = document.createElement('div');
      vacio.className = 'pp-dash__empty';
      var p1 = document.createElement('p');
      p1.className = 'pp-dash__empty-text';
      p1.textContent = 'Todavía no tienes empaques personalizados comprados. Cuando compres uno con tu diseño, aparecerá aquí para pedirlo de nuevo sin rehacerlo.';
      vacio.appendChild(p1);
      listEl.appendChild(vacio);
      syncControls();
      return;
    }
    var grid = document.createElement('div');
    grid.className = 'pp-recompra__perso-grid';
    lista.forEach(function (p) { grid.appendChild(tarjetaPersonalizado(p)); });
    listEl.appendChild(grid);
    // Los personalizados no participan del stepper ni del subtotal: no son
    // renglones de carrito. Se recalcula para que la barra no cuente lo que no
    // se puede agregar.
    syncControls();
  }

  function updateTabs() {
    if (!tabsEl) return;
    tabsEl.querySelectorAll('[data-pp-source]').forEach(function (tab) {
      var on = tab.getAttribute('data-pp-source') === active;
      tab.classList.toggle('is-active', on);
      tab.setAttribute('aria-selected', on ? 'true' : 'false');
    });
  }

  // ── Favoritos: IDs → handles → items ─────────────────────────────
  var IDMAP_CACHE_KEY = 'pp-wishlist-idmap-v1';
  var IDMAP = null;

  function readIdMapCache() {
    try {
      var raw = window.localStorage.getItem(IDMAP_CACHE_KEY);
      if (!raw) return null;
      var parsed = JSON.parse(raw);
      if (!parsed || !parsed.map || parsed.exp < Date.now()) return null;
      return parsed.map;
    } catch (e) { return null; }
  }
  function writeIdMapCache(map) {
    try {
      window.localStorage.setItem(IDMAP_CACHE_KEY, JSON.stringify({ exp: Date.now() + 6 * 60 * 60 * 1000, map: map }));
    } catch (e) {}
  }
  function fetchIdMapPage(page) {
    return fetch('/collections/all?section_id=pp-wishlist-id-map&page=' + page, { credentials: 'same-origin', headers: { 'Accept': 'text/html' } })
      .then(function (res) { return res.ok ? res.text() : null; })
      .then(function (html) {
        if (!html) return null;
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var host = doc.querySelector('.shopify-section') || doc.body;
        try { return JSON.parse((host.textContent || '').trim()); } catch (e) { return null; }
      })
      .catch(function () { return null; });
  }
  function ensureIdMap() {
    if (IDMAP) return Promise.resolve(IDMAP);
    var cached = readIdMapCache();
    if (cached) { IDMAP = cached; return Promise.resolve(IDMAP); }
    return fetchIdMapPage(1).then(function (first) {
      if (!first || !first.map) { IDMAP = {}; return IDMAP; }
      var map = first.map;
      var pages = first.pages || 1;
      if (pages <= 1) { writeIdMapCache(map); IDMAP = map; return map; }
      var rest = [];
      for (var p = 2; p <= pages; p++) rest.push(fetchIdMapPage(p));
      return Promise.all(rest).then(function (results) {
        results.forEach(function (r) {
          var m = r && r.map;
          if (m) { for (var k in m) { if (Object.prototype.hasOwnProperty.call(m, k)) map[k] = m[k]; } }
        });
        writeIdMapCache(map);
        IDMAP = map;
        return map;
      });
    });
  }

  function fetchReorderItem(handle) {
    return fetch('/products/' + encodeURIComponent(handle) + '?section_id=pp-reorder-single', { credentials: 'same-origin', headers: { 'Accept': 'text/html' } })
      .then(function (res) { return res.ok ? res.text() : null; })
      .then(function (html) {
        if (!html) return null;
        var doc = new DOMParser().parseFromString(html, 'text/html');
        return doc.querySelector('[data-pp-reorder-item]');
      })
      .catch(function () { return null; });
  }

  function getFavIds() {
    return new Promise(function (resolve) {
      if (window.PPWishlist && window.PPWishlist.isLoaded && window.PPWishlist.isLoaded()) {
        resolve(window.PPWishlist.getItems() || []);
        return;
      }
      var done = false;
      function ready() {
        if (done) return;
        done = true;
        resolve((window.PPWishlist && window.PPWishlist.getItems && window.PPWishlist.getItems()) || []);
      }
      document.addEventListener('pp-wishlist:ready', ready, { once: true });
      setTimeout(ready, 4000); // fallback si el global no llega
    });
  }

  function loadFavoritos() {
    getFavIds().then(function (ids) {
      if (!ids || !ids.length) {
        buildEmpty('favoritos', 'Aún no tienes favoritos. Guarda productos con el corazón ♥ y aquí podrás recomprarlos en un clic.');
        hideStatus(); mount('favoritos'); afterRender();
        return;
      }
      ensureIdMap().then(function (map) {
        var handles = ids.map(function (id) { return map[String(id)]; }).filter(Boolean);
        if (!handles.length) {
          buildEmpty('favoritos', 'No pudimos cargar tus favoritos ahora. Intenta de nuevo en un momento.');
          hideStatus(); mount('favoritos'); afterRender();
          return;
        }
        Promise.all(handles.map(fetchReorderItem)).then(function (nodes) {
          var frag = document.createDocumentFragment();
          var count = 0;
          nodes.forEach(function (n) { if (n) { frag.appendChild(n); count++; } });
          if (!count) {
            buildEmpty('favoritos', 'No pudimos cargar tus favoritos ahora. Intenta de nuevo en un momento.');
          } else {
            cache.favoritos = frag;
          }
          loaded.favoritos = true;
          hideStatus();
          mount('favoritos');
          afterRender();
        });
      });
    });
  }

  // Consumo Actual: «lo que ya te toca reponer». Desde el 1-oct-2026 sale del
  // MISMO cálculo que «Te Toca Pedir» (GET /customer-te-toca, vía
  // window.PPTeToca): antes leía /customer-restock-due, otra regla (por SKU,
  // desde 2 compras), pintaba la PRIMERA variante del producto y no la que se
  // compró, y sugería cantidad 1. Ahora: la variante exacta (?variant=) y el
  // pedido típico en el stepper.
  function fetchVariante(it) {
    return fetch('/products/' + encodeURIComponent(it.handle) + '?variant=' + encodeURIComponent(it.variant_id || '') + '&section_id=pp-reorder-single', { credentials: 'same-origin', headers: { 'Accept': 'text/html' } })
      .then(function (res) { return res.ok ? res.text() : null; })
      .then(function (html) {
        if (!html) return null;
        var node = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-pp-reorder-item]');
        var q = Number(it.pedido_tipico);
        var input = node && node.querySelector('[data-pp-qty] input');
        if (input && isFinite(q) && q > 0) input.value = String(q);
        return node;
      })
      .catch(function () { return null; });
  }

  function loadConsumo() {
    var TT = window.PPTeToca;
    var vacio = 'Por ahora nada te toca. En Mi Empresa → «Te Toca Pedir» ves cuándo te toca cada producto.';
    var fallo = 'No pudimos calcular tu consumo ahora. Intenta de nuevo en un momento.';
    if (!TT) { buildEmpty('consumo', fallo); hideStatus(); mount('consumo'); afterRender(); return; }
    fetch(TT.ENDPOINT, { credentials: 'same-origin', headers: { 'Accept': 'application/json' } })
      .then(function (res) { return res.json(); })
      .then(function (data) {
        if (!data || !Array.isArray(data.items)) throw new Error('sin items');
        var toca = TT.tocaYa(data.items);
        if (!toca.length) {
          buildEmpty('consumo', vacio);
          hideStatus(); mount('consumo'); afterRender();
          return;
        }
        Promise.all(toca.map(fetchVariante)).then(function (nodes) {
          var frag = document.createDocumentFragment();
          var count = 0;
          nodes.forEach(function (n) { if (n) { frag.appendChild(n); count++; } });
          if (!count) buildEmpty('consumo', fallo);
          else cache.consumo = frag;
          loaded.consumo = true;
          hideStatus();
          mount('consumo');
          afterRender();
          // El stepper recalcula precio y subtotal con su propio listener.
          root.querySelectorAll('[data-pp-qty] input').forEach(function (inp) {
            inp.dispatchEvent(new Event('input', { bubbles: true }));
            inp.dispatchEvent(new Event('change', { bubbles: true }));
          });
        });
      })
      .catch(function () {
        buildEmpty('consumo', fallo);
        hideStatus(); mount('consumo'); afterRender();
      });
  }

  // ── Aside: recomendaciones COMPLEMENTARIAS (motor dedicado) ───────
  // Usa pp-reorder-recs (NO el motor genérico): nunca recomienda la
  // categoría que el cliente ya compra; solo consumibles complementarios.
  function loadRecs() {
    var host = root.querySelector('[data-pp-recs-host]');
    var grid = root.querySelector('[data-pp-recs-grid]');
    if (!host || !grid) return;
    var seed = host.getAttribute('data-seed-handle') || '';
    // El aside nace con skeletons + columna reservada (--has-aside en el Liquid).
    // Si no hay seed o el fetch no trae nada, se esconde y se libera la columna.
    function hideAside() {
      host.hidden = true;
      root.classList.remove('pp-recompra--has-aside');
    }
    if (!seed) { hideAside(); return; }
    fetch('/products/' + encodeURIComponent(seed) + '?section_id=pp-reorder-recs', { credentials: 'same-origin', headers: { 'Accept': 'text/html' } })
      .then(function (res) { return res.ok ? res.text() : null; })
      .then(function (text) {
        if (!text) { hideAside(); return; }
        var doc = new DOMParser().parseFromString(text, 'text/html');
        var cards = doc.querySelectorAll('[data-pp-rec]');
        if (!cards.length) { hideAside(); return; }
        // Reemplaza los skeletons por las cards reales (mismo layout → sin brinco).
        while (grid.firstChild) grid.removeChild(grid.firstChild);
        for (var i = 0; i < cards.length; i++) grid.appendChild(cards[i]);
      })
      .catch(hideAside);
  }

  // "Agregar" en una recomendación → mete el producto a la lista de la
  // izquierda (mismo renglón que el historial vía pp-reorder-single) y lo
  // marca como agregado. Reusa fetchReorderItem.
  function handleRecAdd(btn) {
    var handle = btn.getAttribute('data-handle');
    if (!handle || btn.disabled) return;
    btn.disabled = true;
    var orig = btn.innerHTML;
    btn.textContent = 'Agregando…';
    fetchReorderItem(handle).then(function (node) {
      if (!node) { btn.disabled = false; btn.innerHTML = orig; return; }
      listEl.appendChild(node);
      btn.classList.add('is-added');
      btn.innerHTML = '✓ Agregado';
      recalc();
      syncControls();
    });
  }

  // ── Wiring ───────────────────────────────────────────────────────
  if (tabsEl) {
    tabsEl.addEventListener('click', function (e) {
      var tab = e.target.closest('[data-pp-source]');
      if (!tab || tab.disabled) return;
      switchSource(tab.getAttribute('data-pp-source'));
    });
  }

  if (selectAllEl) {
    selectAllEl.addEventListener('change', function () {
      var on = selectAllEl.checked;
      currentItems().forEach(function (it) {
        var chk = it.querySelector('[data-pp-reorder-check]');
        if (chk && chk.checked !== on) {
          chk.checked = on;
          it.classList.toggle('is-excluded', !on);
        }
      });
      recalc();
      syncControls();
    });
  }

  // Mantener el contador/estado del "seleccionar todo" al tocar checkboxes,
  // steppers o el toggle de incluir (dashboard.js ya recalcula el subtotal).
  root.addEventListener('change', function (e) {
    if (e.target.matches('[data-pp-reorder-check]')) syncControls();
  });
  root.addEventListener('click', function (e) {
    var recAdd = e.target.closest('[data-pp-rec-add]');
    if (recAdd) { handleRecAdd(recAdd); return; }
    if (e.target.closest('[data-pp-qty]')) setTimeout(syncControls, 0);
  });

  // ── Cuenta DEMO (22-oct-2026) ────────────────────────────────────
  // Con la etiqueta `pp-demo` la sección NO rinde el historial de
  // customer.orders (serían las compras REALES de la persona) y marca la
  // raíz con data-pp-demo. «Tu Historial» sale entonces de `recompra` de
  // /apps/crm/customer-demo: productos REALES del catálogo (handle +
  // variant_id) con la cantidad del pedido ficticio, pintados con el MISMO
  // renglón (pp-reorder-single → pp-reorder-item) que Consumo. Sin handle no
  // hay renglón: el precio y el stepper son los de la tienda.
  function loadHistorialDemo() {
    var CD = window.PPCuentaDemo;
    var vacio = 'Cuando hagas tu primera compra, aquí aparecerán los productos para reordenar en un clic.';
    showSkeletonList(5);
    (CD ? CD.pedir() : Promise.resolve(null))
      .then(function (d) {
        var lista = d && Array.isArray(d.recompra) ? d.recompra : [];
        var items = lista.map(CD.linea).filter(function (it) { return it.handle; });
        return Promise.all(items.map(function (it) {
          return fetchVariante({ handle: it.handle, variant_id: it.variant_id, pedido_tipico: it.cantidad });
        })).then(function (nodes) {
          return { nodes: nodes, seed: items.length ? items[0].handle : '' };
        });
      })
      .then(function (r) {
        var frag = document.createDocumentFragment();
        var count = 0;
        r.nodes.forEach(function (n) { if (n) { frag.appendChild(n); count++; } });
        if (count) cache.historial = frag;
        else buildEmpty('historial', vacio);
        if (active === 'historial') { hideStatus(); mount('historial'); }
        afterRender();
        root.querySelectorAll('[data-pp-qty] input').forEach(function (inp) {
          inp.dispatchEvent(new Event('input', { bubbles: true }));
          inp.dispatchEvent(new Event('change', { bubbles: true }));
        });
        var host = root.querySelector('[data-pp-recs-host]');
        if (host && r.seed) host.setAttribute('data-seed-handle', r.seed);
        loadRecs();
      })
      .catch(function () {
        buildEmpty('historial', vacio);
        if (active === 'historial') { hideStatus(); mount('historial'); }
        afterRender();
        loadRecs();
      });
  }

  if (root.hasAttribute('data-pp-demo')) {
    afterRender();
    loadHistorialDemo();
    return;
  }

  loadRecs();
  afterRender();
})();
